import { getAPIPath, requestGooseAPI } from '../shared/request'
import {
  ConfirmPaymentAdminInput,
  CreateStoredPaymentMethodClientInput,
  ExternalStoredPaymentMethodClientDto,
  OrderPaymentClientDtoEx,
} from '../types/api'
import {
  CLIENT_STORED_PAYMENT_METHODS_CANCEL_PATH,
  CLIENT_STORED_PAYMENT_METHODS_CONFIRM_PATH,
  CLIENT_STORED_PAYMENT_METHODS_CREATE_PATH,
  CLIENT_STORED_PAYMENT_METHODS_ID_PATH,
  CLIENT_STORED_PAYMENT_METHODS_PATH,
} from '../types/constants'

export const ClientStoredPaymentMethodsService = {
  list: (locationName: string): Promise<ExternalStoredPaymentMethodClientDto[]> => {
    return requestGooseAPI<ExternalStoredPaymentMethodClientDto[]>({
      url: getAPIPath(CLIENT_STORED_PAYMENT_METHODS_PATH, {
        locationId: locationName,
      }),
      method: 'GET',
    })
  },

  confirm: async (
    locationName: string,
    locationUserProfileId: string,
    orderPaymentId: string,
    data?: ConfirmPaymentAdminInput
  ): Promise<OrderPaymentClientDtoEx> => {
    return requestGooseAPI<OrderPaymentClientDtoEx>({
      url: getAPIPath(CLIENT_STORED_PAYMENT_METHODS_CONFIRM_PATH, {
        locationId: locationName,
        locationUserProfile: locationUserProfileId,
        id: orderPaymentId,
      }),
      method: 'PUT',
      data,
    })
  },

  cancel: async (
    locationName: string,
    locationUserProfileId: string,
    orderPaymentId: string
  ): Promise<OrderPaymentClientDtoEx> => {
    return requestGooseAPI<OrderPaymentClientDtoEx>({
      url: getAPIPath(CLIENT_STORED_PAYMENT_METHODS_CANCEL_PATH, {
        locationId: locationName,
        locationUserProfile: locationUserProfileId,
        id: orderPaymentId,
      }),
      method: 'PUT',
    })
  },

  create: (locationName: string, locationUserProfileId: string, payload: CreateStoredPaymentMethodClientInput) => {
    return requestGooseAPI<OrderPaymentClientDtoEx>({
      url: getAPIPath(CLIENT_STORED_PAYMENT_METHODS_CREATE_PATH, {
        locationId: locationName,
        locationUserProfile: locationUserProfileId,
      }),
      method: 'POST',
      data: payload,
    })
  },

  delete: async (
    locationName: string,
    storedPaymentMethodId: string
  ): Promise<ExternalStoredPaymentMethodClientDto> => {
    return requestGooseAPI<ExternalStoredPaymentMethodClientDto>({
      url: getAPIPath(CLIENT_STORED_PAYMENT_METHODS_ID_PATH, { locationId: locationName, id: storedPaymentMethodId }),
      method: 'DELETE',
    })
  },
}
